module.exports = __webpack_public_path__ + "static/img/hy-logo2.753a340a.png";